<template>
  <div id="app"
       class="flex">
    <Reset_Wapp_QR_Banner v-if="reset_wapp_qr" />

    <div class="only-print fisa-pacient">
      <component :is="printComponent" />
    </div>

    <loading-component />

    <SideMenu v-if="isLogged" />

    <router-view />

    <div v-if="$route.path !== '/statistici'" class="tab-bar" />

    <div v-if="show_modal_programari">
      <Modal_Programari/>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import SideMenu from "@/components/SideMenu.vue";
  import Modal_Programari from "@/components/Modal_Programari.vue";
  import Reset_Wapp_QR_Banner from "@/views/Reset_Wapp_QR_Banner.vue";

  export default {
    name: 'App',
    components: { Reset_Wapp_QR_Banner, SideMenu, Modal_Programari },

    created () {
      this.$store.commit('FILTER_JUDETE');
    },

    computed: {
      ...mapState({
        isLogged: 'isLogged',
        user: 'user',
      }),
      show_modal_programari () {
        return this.$store.state.calendar.show_modal_programari;
      },
      reset_wapp_qr () {
        return this.$store.state.reset_wapp_qr;
      },
      printComponent () {
        const component = this.$store.state.printComponentName
        // eslint-disable-next-line
        return () => import(`@/components/${component}`)
      }
    }
  }
</script>

<style lang="less">
  @import "./assets/styles/var";
  #app {
    margin: 0 auto;
    background-color: @light-white;
  }
  .tab-bar {
    width: 200px;
    margin-left: 74px;
  }
  .side-menu,
  .tab-bar {
    flex: 0 0 auto;
  }
</style>
